import * as React from "react";
import { Controller } from "react-hook-form";
import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";

export const RHFRadioGroup  = (
  props
) => {
  const {control, options, name,disabled,loading } = props;
  return (
    <Controller
    name={name}
    defaultValue=""
    control={control}
    render={({ field }) => (
      <FormControl fullWidth>
        <RadioGroup     
          {...field}
          row
          // onChange={(event, value) => field.onChange(value)}
          onChange={(event, newValue) => {
            // const resolvedId = newValue ? newValue.id : null;
            field.onChange(newValue);
            props.onChange?.(newValue);
          }}
          value={field.value}        
        >
          {options.map((option) => (
            <FormControlLabel
              key={option.id}
              value={option.id}
              control={<Radio />}
              label={option.label}
              disabled={disabled}
            />
          ))}
        </RadioGroup>
      </FormControl>
    )}
  />
  );
};
